// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".events-validation-editor{max-width:100%;position:relative}.events-validation-editor__hours{display:table}.events-validation-editor__hours .hours-heatmap__item{min-width:0}.events-validation-editor__hours .hours-heatmap__label{min-width:6rem;width:6rem}.events-validation-editor__carousel{align-content:flex-start;min-height:0}.events-validation-editor__events-list{overflow:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
